<!-- Menus are wrapped in ng-template for lazy loading menu content -->

<!-- Menu trigger -->
<button mat-icon-button [matMenuTriggerFor]="ClusterOptionsMenu" [disabled]="disabled">
  <mat-icon>more_vert</mat-icon>
</button>

<!-- Main menu -->
<mat-menu #ClusterOptionsMenu="matMenu">
  <ng-template matMenuContent>

    <!-- Add area -->
    <button mat-menu-item
      *ngIf="config.addArea"
      (click)="addArea(cluster)"
      [disabled]="!authService.canCreate('area')">
      <mat-icon>add</mat-icon>
      {{ 'addarea' | translate }}
    </button>

    <mat-divider
      *ngIf="config.addArea && (config.edit || config.delete)">
    </mat-divider>

    <!-- Edit -->
    <button mat-menu-item
      *ngIf="config.edit"
      (click)="edit(cluster)"
      [disabled]="!authService.canUpdate('cluster')">
      <mat-icon>mode_edit</mat-icon>
      {{ 'edit' | translate }}
    </button>

    <!-- Color -->
    <button mat-menu-item
      *ngIf="config.color"
      [matMenuTriggerFor]="colorSubmenu"
      [disabled]="!authService.canUpdate('cluster')">
      <mat-icon>color_lens</mat-icon>
      <!-- {{ 'color' | translate }} -->
      {{ 'backgroundColor' | translate }}
    </button>

    <mat-divider
      *ngIf="(config.addArea || config.edit) && config.delete">
    </mat-divider>

    <!-- Delete -->
    <button mat-menu-item
      *ngIf="config.delete"
      (click)="delete(cluster)"
      [disabled]="!authService.canDelete('cluster')">
      <mat-icon>delete</mat-icon>
      {{ 'delete' | translate: 'plural' }}
    </button>

  </ng-template>
</mat-menu>

<!-- Submenu: Edit status -->
<mat-menu #colorSubmenu="matMenu">
  <ng-template matMenuContent>

      <!-- No color / Revert backgroundcolor -->
      <button mat-menu-item 
        (click)="setColor(cluster, null)"
        [class.active]="!cluster.color">
        <mat-icon>clear</mat-icon>
        {{ 'backgroundColorNone' | translate }}
      </button>

      <mat-divider></mat-divider>

      <!-- Scheme colors -->
      <button mat-menu-item *ngFor="let color of colorScheme"
        (click)="setColor(cluster, color.hex)"
        [class.active]="cluster.color === color.hex">
        <mat-icon [style.color]="color.hex">lens</mat-icon>
        {{ color.displayName }}
      </button>

      <!-- <mat-divider></mat-divider> -->

      <!-- Color picker -->
      <!-- <button mat-menu-item (click)="openColorPicker($event)">
        <mat-icon>home</mat-icon>
        Aangepaste kleur..
      </button> -->

  </ng-template>
</mat-menu>
